import { CallListItem, MakePropsArray } from "interfaces";
import {
  ResponseAttributes,
  CoreUserSettingItem,
  CorePhoneSettingItem,
} from "./CommonTypes";

export type CoreResponseBody =
  | ClientAuthenticateResult
  | ClientLogoutResult
  | UserLoginCheckResult
  | UpdateVersionCheckResult
  | PhoneAccountCreateResult
  | CallListGetResult
  | CallListItemRemoveResult
  | CallListItemAddResult
  | CallListItemEditResult
  | DirectoryResolveResult
  | UserAccountInfoGetResult;

export interface ClientAuthenticateResult {
  ClientAuthenticateResult: {
    $: ResponseAttributes;
    ClientToken: string;
    PhoneUserID: string;
  };
}

export const isClientAuthenticateResult = (
  response: CoreResponseBody
): response is ClientAuthenticateResult => {
  return !!(response as ClientAuthenticateResult).ClientAuthenticateResult;
};

export enum UserLoginStatus {
  notValid,
  notLoggedIn,
  loggedInHere,
  loggedInNotHere,
}

export interface UserLoginCheckResult {
  UserLoginCheckResult: {
    $: ResponseAttributes;
  };
}

export const isUserLoginCheckResult = (
  response: CoreResponseBody
): response is UserLoginCheckResult => {
  return !!(response as UserLoginCheckResult).UserLoginCheckResult;
};

export interface UpdateVersionCheckResult {
  UpdateVersionCheckResult: {
    $: ResponseAttributes;
    AppVersionOK: null;
    AppLoaderVersionOK: null;
  };
}

export const isUpdateVersionCheckResult = (
  response: CoreResponseBody
): response is UpdateVersionCheckResult => {
  return !!(response as UpdateVersionCheckResult).UpdateVersionCheckResult;
};

export interface PhoneAccountCreateResult {
  PhoneAccountCreateResult: {
    $: ResponseAttributes;
  };
}

export const isPhoneAccountCreateResult = (
  response: CoreResponseBody
): response is PhoneAccountCreateResult => {
  return !!(response as PhoneAccountCreateResult).PhoneAccountCreateResult;
};

export interface CallListGetResult {
  CallListGetResult: {
    $: ResponseAttributes;
    CallList: {
      $: {
        Type: string;
        BaseIndex: number;
        Count: number;
        SortField: string;
        SortDir: string;
      };
      CallListItem?: CallListItem | CallListItem[];
    };
  };
}

export const isCallListGetResult = (
  response: CoreResponseBody
): response is CallListGetResult => {
  return !!(response as CallListGetResult).CallListGetResult;
};

export interface CallListItemRemoveResult {
  CallListItemRemoveResult: {
    $: ResponseAttributes;
  };
}

export const isCallListItemRemoveResult = (
  response: CoreResponseBody
): response is CallListItemRemoveResult => {
  return !!(response as CallListItemRemoveResult).CallListItemRemoveResult;
};

export interface CallListItemAddResult {
  CallListItemAddResult: {
    $: ResponseAttributes;
  };
}

export const isCallListItemAddResult = (
  response: CoreResponseBody
): response is CallListItemAddResult => {
  return !!(response as CallListItemAddResult).CallListItemAddResult;
};

export interface CallListItemEditResult {
  CallListItemEditResult: {
    $: ResponseAttributes;
  };
}

export const isCallListItemEditResult = (
  response: CoreResponseBody
): response is CallListItemEditResult => {
  return !!(response as CallListItemEditResult).CallListItemEditResult;
};

export type CoreSettingsGetResponse = {
  $: {
    Id: string;
  };
  PhoneSettingsGetResult?: CorePhoneSettingsGetResult;
  UserSettingsGetResult?: CoreUserSettingsGetResult;
};

export type CoreSettingsSetResponse = {
  $: {
    Id: string;
  };
  PhoneSettingsSetResult?: Array<{ $: ResponseAttributes }>;
  UserSettingsSetResult?: Array<{ $: ResponseAttributes }>;
};

export type CorePhoneSettingsGetResult = Array<{
  $: ResponseAttributes;
  PhoneSettingItem?: Array<CorePhoneSettingItemArrd>;
}>;

export type CoreUserSettingsGetResult = Array<{
  $: ResponseAttributes;
  UserSettingItem?: Array<CoreUserSettingItemArrd>;
}>;

export type CorePhoneSettingItemArrd = MakePropsArray<CorePhoneSettingItem>;

export type CoreUserSettingItemArrd = MakePropsArray<CoreUserSettingItem>;
export interface DirectoryResolveResult {
  DirectoryResolveResult: {
    $: ResponseAttributes;
    DirectoryItem: {
      Name: string;
      DialString: string;
      UserOnlineFlag: boolean;
      PhoneOnlineFlag: boolean;
      NewNumber: string;
      CallerBlocked: boolean;
      URIList: {
        URI: {
          $: {
            Network: string;
            Priority: number;
            Preference: number;
          };
          _: string;
        }[];
      };
      Source: string;
      AnonymousCallerBlocked: boolean;
      VideoMsgData: {
        VideoMessageSupported: boolean;
        NumberRings: number;
        MaxRecordSeconds: number;
        DownloadSpeed: number;
        GreetingPreference: number;
        GreetingURL: string;
        GreetingText: string;
        CountdownEmbedded: boolean;
      };
    };
  };
}

export const isDirectoryResolveResult = (
  response: CoreResponseBody
): response is DirectoryResolveResult => {
  return !!(response as DirectoryResolveResult).DirectoryResolveResult;
};

export interface UserAccountInfoGetResult {
  UserAccountInfoGetResult: {
    $: ResponseAttributes;
    Name: string;
    PhoneNumber: number;
    TollFreeNumber: number;
    LocalNumber: number;
    AssociatedPhone: number;
    CurrentPhone: number;
    HomePhone: number;
    Address1: string;
    Address2: string;
    City: string;
    State: string;
    ZipCode: number;
    Email: string;
    EmailMain: string;
  };
}

export interface ClientLogoutResult {
  ClientLogoutResult: {
    $: ResponseAttributes;
  };
}
